import * as React from 'react'
import styled from 'styled-components'
import {observer} from 'mobx-react'
import {raise, Intent, theme} from '../theme'
import {FiX} from 'react-icons/fi'

import {NotificationStore} from '../stores/NotificationStore'
import {Card, getTextColor} from '../elements/Card'

interface INotificationProps {
  notificationStore: NotificationStore
  sticky?: boolean
  className?: string
}

interface IState {
  duration: number
}

@observer
class NotificationClass extends React.Component<INotificationProps> {
  public readonly state: IState = {
    duration: 10
  }

  public componentDidUpdate = () => {
    if (this.props.notificationStore.notification.message && !this.props.sticky && !this.props.notificationStore.notification.sticky) {
      setTimeout(() => {
        this.props.notificationStore.hideNotification()
      }, this.state.duration * 1000)
    }
  }
  private handleClose = () => {
    this.props.notificationStore.hideNotification()
  }

  render() {
    const {notification} = this.props.notificationStore
    return notification.message ? (
      <Card type={notification.type} className={this.props.className} backgroundColor>
        <NotificationAction>
          <CloseButton size={21} onClick={this.handleClose} />
        </NotificationAction>
        <p dangerouslySetInnerHTML={{__html: notification.message}} />
        <SliderContainer>
          <Slider duration={this.state.duration} type={notification.type} />
        </SliderContainer>
      </Card>
    ) : null
  }
}

const NotificationAction = styled.div`
  display: flex;
  justify-content: flex-end;
`
export const Notification = styled(NotificationClass)`
  position: fixed;
  bottom: 20px;
  left: 20px;
  font-size: 16px;
  padding: 0.8rem;
  width: 380px;
  height: auto;
  opacity: 1;
  z-index: 10;
  display: flex;
  flex-direction: column;
  margin: 0 auto auto auto;
  ${raise(2)};
  p {
    margin-top: 6px;
  }
  animation: move-down 0.5s forwards;
  @keyframes move-down {
    to {
      margin-top: 80px;
    }
  }

  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    left: 0;
    bottom: 0;
  }
`

const SliderContainer = styled.div`
  width: 100%;
  height: 5px;
  margin-top: 0.3rem;
`

const Slider = styled.div<{duration: number; type?: Intent}>`
  background-color: ${props => getTextColor(props.type || 'neutral')};
  width: 0%;
  height: 100%;
  animation: ${props => `slide ${props.duration}s forwards`};
  animation-delay: 0.2s;
  @keyframes slide {
    to {
      width: 100%;
    }
  }
`

const CloseButton = styled(FiX)`
  cursor: pointer;
`
